module.exports = __webpack_public_path__ + "static/media/conference-catering-1.6f0db60e.jpg";